import type { KadeweUser } from "~/types";

export default defineNuxtRouteMiddleware((to) => {
    const user = useSanctumUser<KadeweUser>();
    const localePath = useLocalePath();

    if (!user.value?.foth.is_foth) {
        console.warn("FOTH: Only FOTH users have access to", to.path);
        return navigateTo(localePath("/portal/card"));
    }
});
